<div [ngClass]="{'allocation':isAllocationSheet()}" class="assign-personal">
    <div style="opacity: 0; pointer-events: none; height: 0px">
        <mat-form-field>
            <mat-select
                [formControl]="personnelFormCtrl"
                [multiple]="true"
                #personnelSelector
            >
                <mat-option>
                    <ngx-mat-select-search
                        noEntriesFoundLabel="No results found"
                        placeholderLabel="Find a person..."
                        [formControl]="personnelFilterFormCtrl"
                    >
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option
                    *ngFor="let person of filteredPersonnel | async"
                    [value]="person"
                    (click)="addOrRemovePersonnel(person)"
                >
                    {{ person.staffDetails.contactDetails.firstName }}
                    {{ person.staffDetails.contactDetails.lastName }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <table class="table table-borderless rows-no-padding">
        <tr *ngFor="let personnel of personnelFormCtrl?.value; let i = index"  class="table-row">
            <td class="align-middle">
                <i class="fas fa-check-square main-color margin-right-5"></i>
                {{ personnel.staffDetails.contactDetails.firstName }}
                {{ personnel.staffDetails.contactDetails.lastName }}
            </td>
            <td class="align-middle text-sm-right">
               
                <i  *ngIf="personnel.allocatedPersonnelHoursForSupervisors.length"
                    class="d-inline-block fas fa-exclamation-circle cursor-pointer"
                    data-toggle="popover"
                    style="color: red"
                    data-trigger="hover"
                    data-html="true"
                    [popover]="popTemplate"
                    triggers="mouseenter:mouseleave"
                >
                </i>

                <ng-template #popTemplate>
                    <div
                        [innerHtml]="
                            personnelPopupContent(
                                personnel.allocatedPersonnelHoursForSupervisors
                            )
                        "
                    ></div>
                </ng-template>
            </td>
            <td class="align-middle text-sm-right">
                <input
                    *ngIf="!isAllocationSheet()"
                    [(ngModel)]="personnel.hours"
                    (blur)="updateAllocatedPersonnelList()"
                    [disabled]="controlDisabled"
                    class="form-control form-control-sm float-right no-border"
                    style="max-width: 80px"
                    oninput="(this.value == '' ? this.value = 0 : '')"
                    step=".01"
                    type="number" min="1" max="24" required/> 
                <span *ngIf="isAllocationSheet()">
                    {{ personnel.hours }}
                </span>
            </td>
            <td class="align-middle">
                <button
                    *ngIf="!isAllocationSheet()"
                    class="btn btn-sm"
                    [disabled]="controlDisabled"
                    (click)="removeItem(personnel.staffId)"
                >
                    <i class="fa fa-trash"></i>
                </button>
            </td>
        </tr>
    </table>

    <button
        class="btn btn-default"
        *ngIf="!isAllocationSheet()"
        [disabled]="controlDisabled"
        (click)="personnelSelector.open()"
    >
        <i class="fas fa-plus"></i> {{ l("Add") }}
    </button>

    <button
        class="btn btn-default"
        *ngIf="isAllocationSheet()"
        (click)="edit()"
    >
        <i class="fas fa-edit"></i> {{ l("Edit") }}
    </button>
    <div class="validation-msg" *ngIf="showError()&&!anyResourceSelected">{{ l('MinResourceSelectionCriteria') }}</div>
</div>
